export const hospitalClaimsColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'adjustment_amount',
  'bill_code',
  'bill_date',
  'bill_date_external',
  'bill_status',
  'bill_type_name',
  'bucket_id',
  'claim_amount',
  'claim_number',
  'contract_verbiage',
  'expected_payment',
  'facility_id',
  'fk_hospital__data_doc_new_id',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'paid_amount',
  'payer_code',
  'payer_name',
  'payer_position',
  'snapshot_id',
  'type_of_bill',
];
